<ng-container *transloco="let t; prefix: scope">
  <mat-form-field class="w-full" [floatLabel]="autoFocus() ? 'always' : 'auto'" appearance="outline" subscriptSizing="dynamic">
    @if (showLabel()) {
      <mat-label>{{ placeholder() }}</mat-label>
    }

    @if (showPrefix()) {
      <rma-icon
        [class.animate-spin]="state().loading()"
        [glyph]="state().loading() ? 'sync' : 'search'"
        [theme]="prefixTheme()"
        matPrefix
      />
    }

    <input
      #autocomplete
      aria-autocomplete="none"
      type="search"
      [formControl]="inputControl"
      [matAutocomplete]="auto"
      [placeholder]="placeholder() ?? ''"
      [matAutocompletePosition]="position()"
      (focus)="onFocus()"
      matInput
      autocomplete="off"
      data-id="search-input"
    />

    @if (showSuffix() && state().loading()) {
      <rma-icon class="animate-spin" [theme]="suffixTheme()" matIconSuffix glyph="sync" />
    } @else if (searchTerm()) {
      <button rma-icon-button aria-label="Clear search" type="button" (click)="onClear()" matSuffix>
        <rma-icon [theme]="suffixTheme()" glyph="clear" />
      </button>
    } @else if (showSuffix()) {
      <rma-icon class="!p-3" [rounded]="true" matIconSuffix glyph="search" theme="primary-alt" />
    }

    <mat-autocomplete
      #auto="matAutocomplete"
      #scrollbar
      [class]="autcompleteClass()"
      [displayWith]="displayFn"
      [fromRoot]="true"
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      [infiniteScrollDisabled]="state().loading() || !searchTerm()"
      (optionSelected)="onOptionSelected($event)"
      (opened)="opened.emit()"
      (closed)="closed.emit()"
      (scrolled)="onScrolled()"
      infiniteScroll
      infiniteScrollContainer=".search-results-panel"
    >
      @if (searchTerm()) {
        @for (option of state().results?.results; track option.id) {
          <mat-option [value]="option" data-id="search-result">
            <div class="flex items-start text-steel-100">
              @if (template() === 'Location') {
                <rma-icon glyph="location_on" />
                <div>
                  <span [innerHTML]="option.name | typeAheadHighlight: searchTerm()"></span>
                  @if (option.secondaryName) {
                    <small class="line-clamp-1 text-steel-60">
                      <span>
                        {{ t('result.' + (option.secondaryName | lowercase) + '.label') }}
                      </span>
                    </small>
                  }
                </div>
              } @else {
                @if (option.imageUrl) {
                  <img
                    rmaBrokenImage
                    class="mr-4 h-10 w-10 rounded-full object-cover"
                    [src]="option.imageUrl"
                    [alt]="option.name"
                    [fallbackSrc]="placeholderImage()"
                    height="2.5rem"
                    width="2.5rem"
                  />
                }
                <div>
                  <span [innerHTML]="option.name | typeAheadHighlight: searchTerm()"></span>
                  <small class="line-clamp-1 text-steel-60">
                    @switch (selectedSearchType()) {
                      @case ('Agencies') {
                        <span>
                          {{ t(option.agentGroupingType | autoSearchGroupingLabel: option.agentCount, { count: option.agentCount }) }}
                        </span>
                      }
                      @case ('Agents') {
                        <span> {{ option.secondaryName }} </span>
                      }
                    }
                  </small>
                </div>
              }
            </div>
          </mat-option>
        } @empty {
          @if (!state().loading()) {
            <mat-option class="no-results h-48 items-center" disabled>
              <div class="flex w-full flex-col items-center justify-center">
                <p class="text-lg">{{ t('no-result.label') }}</p>
                <p class="text-lg font-bold">{{ inputControl.value }}</p>
                <p class="text-md">{{ t('no-result.message') }}</p>
              </div>
            </mat-option>
          }
        }
        @if (showCreateProfile() && searchTerm()) {
          <div
            class="bottom-0 w-full bg-blue-10 px-4 py-2 text-blue-90"
            [class.absolute]="results() === null ? false : results()!.total > 1"
          >
            {{ t('searchprofile.unableToFindProfile') }}
            <a [routerLink]="['../create-profile']" queryParamsHandling="preserve">{{ t('searchprofile.createProfile') }}</a>
          </div>
        }
      }
    </mat-autocomplete>
  </mat-form-field>

  @if (searchByAddressLoading()) {
    <div class="rma-loader">
      <mat-spinner />
    </div>
  }
</ng-container>
